// extracted by css-extract-rspack-plugin
export default {"container":"u8Jgtz","spinner":"Ynv4GG","circle":"bFk59K","spin":"SZ5PRC","icon":"_7U4yU5"};